import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  wrapper: {
    height: 42,
    minWidth: 72,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    columnGap: 8,
    borderTopWidth: 1,
    borderBottomWidth: 1,
  },
  textWrapper: {
    minWidth: 72,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  label: {
    fontSize: 14,
    paddingHorizontal: 8,
  },
  firstButtonBorder: {
    borderBottomLeftRadius: 8,
    borderTopLeftRadius: 8,
    borderRightWidth: 0,
    borderLeftWidth: 1,
  },
  lastButtonBorder: {
    borderBottomRightRadius: 8,
    borderTopRightRadius: 8,
    borderLeftWidth: 0,
    borderRightWidth: 1,
  },
});

export default style;
